import i18n from '@/i18n/index';

const translations = Object.freeze({
  nl: 'en',
  fr: 'et',
  en: 'and',
  pl: 'i',
});

export function arrToSentence(arr) {
  const arr_clone = _.cloneDeep(arr);
  let lastWord = '';
  if (arr_clone.length > 1) {
    lastWord = ` ${translations[i18n.global.locale.value]} ${arr_clone.pop()}`;
  }
  return arr_clone.join(', ') + lastWord;
}

export function titleize(s) {
  if (typeof s === 'string') {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  // do nothing in case of null/undefined/...
  return s;
}

export function orderAlphabetically({ collection, val = 'attributes.name', direction = 'asc' }) {
  return _.orderBy(collection, [val.toLowerCase()], [direction]);
}

export function formatFileSize(bytes, decimalPoint, k = 1000) {
  if (bytes === 0) return '0 Bytes';
  const dm = decimalPoint || 0;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export function collapseSpaces(string) {
  return string.replace(/\s+/g, ' ').trim();
}
